import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import ArrowIcon from '../../Component/ArrowIcon';
import ServiceImage from '../../Component/Images/services-img.png';
import { Container } from '../../Component/styledComponents/styledComponents';

const Root = styled.div`
background-color: #0a0a0a;
padding:80px 0;
color:#fff;
position: relative;
@media(max-width:767px){
    padding:30px 0;
}
`;
const LeftWrapper = styled.div`
width:50%;
@media(max-width:767px){
    width:100%;
}
`;
const RightWrapper = styled.div`
width:50%;
position: relative;
height: 100%;
display: flex;
align-items: baseline;
justify-content: right;
@media(max-width:767px){
    display: none;
}
`;
const Heading = styled.h4`
 margin: 0;
 background-image: linear-gradient(to top, #00dea3, #037474), linear-gradient(to bottom, #fff, #fff);
 -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 60px;
  font-weight: 900;
  margin-bottom:40px;
  @media(max-width:1221px){
    font-size: 50px;
  }
  @media(max-width:1004px){
    font-size: 40px;
  }
  @media(max-width:552px){
    font-size: 30px;
  }
`;

const ListSection = styled.div`
 padding-left:30px;
 @media(max-width:500px){
    padding-left:15px;
 }
`;
const List = styled.div`
display: flex;
font-size:20px;
margin-bottom:20px;
align-items: center;
:hover{
    color:#00a97c;
}
@media(max-width:552px){
    font-size: 16px;
    margin-bottom:15px;
}
`;
const Icon = styled.div`
margin-right:20px;
`;
const Image = styled.img`
position: absolute;
right: 100px;
bottom:0;
width:500px;
@media(max-width:1300px){
    right:0px;
}
@media(max-width:857px){
    width:400px;
}
@media(max-width:767px){
    display: none;
}
`;


const ButtonContainer = styled.div`
 display: flex;
 width:100%;
 align-items: center;
 justify-content: center;
 margin-top:50px;
 position: relative;
 z-index: 2;
 @media(max-width:767px){
    margin-top:20px;
 }
 @media(max-width:500px){
    margin-top:10px;
 }
`;

const Button = styled.button`
background:none;
border:1px solid #00a97b;
padding: 15px 30px;
border-radius:30px;
color:#fff;
font-size:16px;
cursor: pointer;
`;
function SollutionSection(props) {
    const navigate = useNavigate();
    return (
        <Root>
            <Container>
                <LeftWrapper>
                    <Heading>Services we offer for NFT Marketplace</Heading>
                        <ListSection>
                           <List><Icon><ArrowIcon width="30px"/></Icon>NFT Marketplace Design  </List>
                           <List><Icon><ArrowIcon width="30px"/></Icon>NFT Marketplace Maintenance  </List>
                           <List><Icon><ArrowIcon width="30px"/></Icon>NFT Development  </List>
                           <List><Icon><ArrowIcon width="30px"/></Icon>NFT Wallet Development  </List>
                           <List><Icon><ArrowIcon width="30px"/></Icon>NFT Consulting </List>
                           <List><Icon><ArrowIcon width="30px"/></Icon>NFT Token Development  </List>
                        </ListSection>
                </LeftWrapper>
                <RightWrapper>
                </RightWrapper>
            </Container>
            <ButtonContainer>
                <Button onClick={()=>{navigate('/contact_us')}}>Start A Project</Button>
            </ButtonContainer>
         <Image src={ServiceImage} alt="NFT Marketplace Development" />
        </Root>
    );
}

export default SollutionSection;